import { GatewayDeclarationActivite } from "@conformite/gateway";
import { displayErrorToast } from "@endya-conformite/ui-kit";
import { GatewayDeclarationActiviteApi } from "@src/api/conformite/declarationActivite.api";
import { handleGatewayError } from "@src/api/utils/handleGatewayError";
import { useCallback, useEffect, useState } from "react";

type DeclarationActiviteState = {
  ias: GatewayDeclarationActivite.DeclarationActiviteIas | null;
  iobsp: GatewayDeclarationActivite.DeclarationActiviteIobsp | null;
  isLoading: boolean;
  error: string | null;
};

export const useDeclarationActiviteAdmin = (
  siren: string | undefined,
  millesime: number | undefined
) => {
  const [state, setState] = useState<DeclarationActiviteState>({
    ias: null,
    iobsp: null,
    isLoading: false,
    error: null,
  });

  const fetchDeclarationActivite = useCallback(async () => {
    if (!siren || !millesime) return;

    setState((prev) => ({ ...prev, isLoading: true, error: null }));

    try {
      const [iasData, iobspData] = await Promise.all([
        GatewayDeclarationActiviteApi.getIASAdmin(siren, millesime),
        GatewayDeclarationActiviteApi.getIobspAdmin(siren, millesime),
      ]);

      setState({
        ias: iasData,
        iobsp: iobspData,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      handleGatewayError({
        onUnhandled: () => {
          displayErrorToast(
            "Une erreur est survenue lors de la récupération des déclarations d'activité"
          );
        },
      })(error);

      setState((prev) => ({
        ...prev,
        isLoading: false,
        error: "Erreur lors du chargement des déclarations d'activité",
      }));
    }
  }, [siren, millesime]);

  useEffect(() => {
    void fetchDeclarationActivite();
  }, [fetchDeclarationActivite]);

  return {
    ...state,
    refetch: fetchDeclarationActivite,
  };
};
